module.exports = __webpack_public_path__ + "static/media/Adaptogens.72aa3787.png";